import { Box, TextField, InputAdornment, Stack, Chip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export function VariableFilter({
  searchTerm,
  setSearchTerm,
  categories,
  activeTab,
  setActiveTab,
  theme,
}) {
  return (
    <>
      <Box sx={{ px: 2, pb: 1.5 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Pesquisar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 18, color: "text.secondary" }} />
              </InputAdornment>
            ),
            sx: {
              borderRadius: "8px",
              bgcolor: "#f1f3f4",
              "& fieldset": { border: "none" },
            },
          }}
        />
      </Box>

      <Box sx={{ px: 2 }}>
        <Stack
          direction="row"
          flexWrap="wrap"
          sx={{
            py: 0.5,
            gap: 1,
          }}
        >
          {categories.map((cat) => (
            <Chip
              key={cat}
              label={cat}
              onClick={() => setActiveTab(cat)}
              sx={{
                fontWeight: 600,
                fontSize: "14px",

                bgcolor:
                  activeTab === cat ? theme.palette.primary.main : "#eee",

                "& .MuiChip-label": {
                  color: activeTab === cat ? "#fff" : "#555",
                  whiteSpace: "nowrap",
                },

                "&:hover": {
                  bgcolor:
                    activeTab === cat
                      ? theme.palette.primary.dark 
                      : "#e0e0e0",
                },

                "&:active": {
                  bgcolor:
                    activeTab === cat ? theme.palette.primary.dark : "#d5d5d5",
                },
              }}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
}
